import cx from "classnames";

/**
 * USDX brand mark, drawn rather than loaded from an image.
 *
 * The design handoff specifies the lockup as a rounded tile carrying a "U" in
 * the condensed display face — no bitmap involved. Building it in markup means
 * there is no third-party logo file to go stale, and it stays crisp at any size.
 *
 * `onGradient` is the header treatment (white tile, deep-blue letter);
 * `standalone` inverts it for light panels.
 */
type Props = {
  size?: number;
  variant?: "onGradient" | "standalone";
  className?: string;
};

export function UsdxMark({ size = 38, variant = "onGradient", className }: Props) {
  const onGradient = variant === "onGradient";

  return (
    <span
      className={cx(
        "grid shrink-0 place-items-center",
        onGradient ? "bg-white/90 shadow-[0_4px_10px_rgba(0,0,0,0.18)]" : "bg-[#236f92]",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.29),
      }}
      aria-hidden="true"
    >
      <span
        style={{
          fontFamily: '"Barlow Condensed", "Relative", system-ui, sans-serif',
          fontWeight: 700,
          fontSize: Math.round(size * 0.53),
          lineHeight: 1,
          letterSpacing: "0.5px",
          color: onGradient ? "#236f92" : "#ffffff",
        }}
      >
        U
      </span>
    </span>
  );
}
